<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>渠道映射关系</span>
            <a class="icon-index-1 jm-fr" @click="handleAdd">
              <el-button
                type="primary"
                size="medium">添加新映射关系</el-button>
            </a>
          </div>
          <el-form label-width="6em" :inline="true" :model="searchData">
            <el-form-item label="原渠道来源">
              <jm-channel
                v-model="searchData.channel"
                clearable
                filterable
              />
              <el-form-item label="原渠道ID" >
                <el-input v-model="searchData.custom_from_final" clearable placeholder="原渠道ID"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="jm-input-common3"
                  type="primary"
                  :loading="exporting"
                  @click="sendForm">搜索</el-button>
              </el-form-item>
            </el-form-item>
          </el-form>
          <jm-tableList
            url="/training/channel/getChannelMappingList"
            :refresh.sync="exporting"
            :search-data="searchData"
            class="adminList">
            <el-table-column slot="firstColumn" width="50" label="序号" type="index"></el-table-column>
            <el-table-column
              fixed="right"
              slot="lastColumn"
              label="操作"
              class-name="scope-button-list"
              width="350px"
            >
              <template slot-scope="scope">
                <el-row>
                  <el-button size="mini" v-if="scope.row.IsActive == 1" type="danger" @click="disableChannelMapping(scope.row)">禁用</el-button>
                  <el-button size="mini" v-if="scope.row.IsActive == 0" type="primary" @click="enableChannelMapping(scope.row)">启用</el-button>
                </el-row>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
    <el-dialog width="30%" title="添加渠道映射关系" :visible.sync="dialogFormVisible" >
      <el-form :model="formAdd" label-width="100px">
        <el-form-item label="原渠道ID: " >
          <el-input v-model="formAdd.OldChannelId" clearable placeholder="原渠道ID"></el-input>
        </el-form-item>
        <el-form-item label="新渠道ID: " >
          <el-input v-model="formAdd.NewChannelId" clearable placeholder="新渠道ID"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addChannelMapping()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';
import { jmChannel } from '@/components/tool';

export default {
  components: {
    jmTableList,
    jmChannel
  },
  data() {
    return {
      searchData: {},
      exporting: false,
      dialogFormVisible: false,
      formAdd: {
        OldChannelId: '',
        NewChannelId: '',
      },
    };
  },
  created () {
  },
  methods: {
    handleAdd () {
      this.dialogFormVisible = true;
    },
    addChannelMapping () {
      if (Number.isNaN(Number(this.formAdd.OldChannelId))) {
        this.$message.error('原渠道ID必须为数字');
        return false;
      }
      if (Number(this.formAdd.OldChannelId) === 0) {
        this.$message.error('原渠道ID不能为空');
        return false;
      }
      if (Number(this.formAdd.NewChannelId) === 0) {
        this.$message.error('新渠道ID不能为空');
        return false;
      }
      if (Number.isNaN(Number(this.formAdd.NewChannelId))) {
        this.$message.error('新渠道ID必须为数字');
        return false;
      }
      // post data
      this.$http
        ._post({
          data: {
            addData: this.formAdd
          },
          url: '/training/channel/addChannelMapping'
        })
        .then(({ data }) => {
          if (data === '数据库错误' || data === '顺序重复') {
            this.$message.error(data);
          } else {
            this.$message.success(data);
            this.dialogFormVisible = false;
            this.exporting = true;
          }
        });
    },
    disableChannelMapping(row) {
      this.$confirm('确定删除吗？确定后改变为禁用状态', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          data: {
            data: { Id: row.Id, op: 'disable' }
          },
          url: '/training/channel/ableChannelMapping'
        })
          .then(({ data }) => {
            if (data === '数据库错误' || data === '顺序重复') {
              this.$message.error(data);
            } else {
              this.$message.success(data);
              this.exporting = true;
            }
          });
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消禁用',
        });
      });
    },
    enableChannelMapping(row) {
      this.$confirm('确定启用吗？确定后改变为启用状态', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          data: {
            data: { Id: row.Id, op: 'enable' }
          },
          url: '/training/channel/ableChannelMapping'
        })
          .then(({ data }) => {
            if (data === '数据库错误' || data === '顺序重复') {
              this.$message.error(data);
            } else {
              this.$message.success(data);
              this.exporting = true;
            }
          });
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消启用',
        });
      });
    },
    sendForm () {
      this.exporting = true;
    },
  },
  mounted () {
  },
  watch: {
  },
};
</script>
